"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _commonUIColors = require("../../utils/commonUIColors");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validSizeVariantCombinations = Object.keys(_constants.sizeStyles);

function variantValidator(props, propName, componentName) {
  if (process.env.NODE_ENV !== 'production') {
    var size = props.size,
        variant = props[propName];

    if (!validSizeVariantCombinations.includes("".concat(size, ".").concat(variant))) {
      return Error("The Badge component does not support the '".concat(size, "' size and '").concat(variant, "' variant props combination."));
    }

    _propTypes.default.checkPropTypes({
      variant: _propTypes.default.oneOf(['round', 'square'])
    }, props, propName, componentName);

    return null;
  }

  return null;
}

var propTypes = {
  color: _propTypes.default.oneOf(_commonUIColors.commonUIColorKeys),
  icon: _propTypes.default.elementType.isRequired,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  variant: variantValidator
};
exports.propTypes = propTypes;
var defaultProps = {
  size: 'medium',
  variant: 'round'
};
exports.defaultProps = defaultProps;